"use strict";Object.defineProperty(exports, "__esModule", {value: true});

// Lines patients read, so straight quotes only: a curly apostrophe turns a
// text into UCS-2 and can double its segment count.

const named = (k) => `${k.Keyword} ${k.Phrase}`

/* The welcome line: each flagged keyword with its phrase, "A, B or C". */
 const welcomeLine = (keywords) => {
  const parts = keywords.filter(k => k.Flags).map(named)
  if (!parts.length) return ''
  const last = parts.pop()
  return `Reply ${parts.length ? `${parts.join(', ')} or ` : ''}${last}.`
}; exports.welcomeLine = welcomeLine

 const promptLines = (k, phoneNumber) => [
  { label: 'In a text or template', text: `Reply ${k.Keyword} anytime ${k.Phrase}.` },
  {
    label: 'After-hours reply',
    text: `We're closed and will reply when we open at 8 AM. Reply ${k.Keyword} anytime. For a crisis, call or text 988.`,
  },
  {
    label: 'Flyer or website',
    text: `Text ${k.Keyword} to ${phoneNumber}. Msg & data rates may apply. Reply STOP to opt out.`,
  },
]; exports.promptLines = promptLines
